import React from 'react';
import { colors } from 'seedling/constants';
import styled from 'styled-components';

const xIconSvg = ({ size, color, className, onClick }) => (
  <svg
    width={size}
    height={size}
    className={className}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="nonzero"
        d="M11.0985261,8.72517045 L11.0985261,2.41146195 C11.0985261,1.8591772 10.6508108,1.41146195 10.0985261,1.41146195 C9.54624133,1.41146195 9.09852608,1.8591772 9.09852608,2.41146195 L9.09852608,8.72517045 L2.78481758,8.72517045 C2.23253283,8.72517045 1.78481758,9.1728857 1.78481758,9.72517045 C1.78481758,10.2774552 2.23253283,10.7251704 2.78481758,10.7251704 L9.09852608,10.7251704 L9.09852608,16.8834573 C9.09852608,17.4357421 9.54624133,17.8834573 10.0985261,17.8834573 C10.6508108,17.8834573 11.0985261,17.4357421 11.0985261,16.8834573 L11.0985261,10.7251704 L17.256813,10.7251704 C17.8090977,10.7251704 18.256813,10.2774552 18.256813,9.72517045 C18.256813,9.1728857 17.8090977,8.72517045 17.256813,8.72517045 L11.0985261,8.72517045 Z"
        transform="rotate(45 10.02 9.647)"
      />
    </g>
  </svg>
);

const XIcon = styled(xIconSvg)`
  vertical-align: ${props => props.verticalAlign};
  cursor: pointer;

  &:hover {
    path {
      fill: ${props => props.hoverColor};
    }
  }
`;

XIcon.displayName = 'XIcon';

XIcon.defaultProps = {
  size: '20px',
  color: colors.mediumGrey,
  hoverColor: colors.darkestGrey,
  verticalAlign: 'middle',
};

export default XIcon;
